export default "__VITE_ASSET__DmqD4A5___"